<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">温馨提示</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>跳转类型：</label>
          <el-select v-model="urlType" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in urlTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editWarmTipDialog(-1)">新建提示</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="title" label="提示标题" v-if="checkColList.indexOf('提示标题') > -1"></el-table-column>
          <el-table-column property="" label="链接" v-if="checkColList.indexOf('链接') > -1" width="300">
            <template #default="scope">
              <el-tag v-if="scope.row.urlType == 1">内置浏览器</el-tag>
              <el-tag v-if="scope.row.urlType == 2" class="ml-2" type="success">外部浏览器</el-tag>
              <el-link style="margin-left: 8px;" type="primary" :href="scope.row.url" target="_blank">{{scope.row.url}}</el-link>
            </template>
          </el-table-column>
          <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"></el-table-column>
          <el-table-column property="" label="标注重要" v-if="checkColList.indexOf('标注重要') > -1">
            <template #default="scope">
              <span :style="{color: scope.row.tag == 1?'red': ''}">
								{{scope.row.tag==1?'是':'否'}}
							</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state==1?'待展示':scope.row.state==2?'展示中':scope.row.state==3?'已下架':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editWarmTipDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-show="scope.row.state == 1 || scope.row.state == 3" @click="updateState(scope.$index, scope.row, 2)">上架</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-show="scope.row.state == 1 || scope.row.state == 2" @click="updateState(scope.$index, scope.row, 3)">下架</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getSysWarmTipPageList, updateSysWarmTipState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import WarmTipDialog from "./components/WarmTipDialog";
import DatePickerRange from '../../components/DatePickerRange'

export default {
  name: "SysWarmTip",
  components: { DatePickerRange },
  data() {
    return {

      stateArray: [
        {value: -1, label: '不限'},
        {value: 1, label: '待展示'},
        {value: 2, label: '展示中'},
        {value: 3, label: '已下架'}
      ],
      state: 1,

      urlTypeArray: [
        {label : '不限制', value : -1},
        {label : '内置浏览器', value : 1},
        {label : '外部浏览器', value : 2}
      ],
      urlType: -1,

      //刷新组
      colList: ['创建时间', '提示标题', '链接', '排序', '标注重要', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,
    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = 1;
      this.urlType = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['state'] = this.state;
      param['urlType'] = this.urlType;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSysWarmTipPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editWarmTipDialog(idx, row) {
      let _title = '';
      let tipForm = {}
      if (idx > -1) {
        _title = '编辑标签'
        tipForm = Object.assign({}, row);
      }else {
        _title = '新建标签'
      }
      Dialog.open({
        title: _title,
        component: WarmTipDialog,
        data: {
          tipForm: tipForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          if(idx > -1) {
            row.title = result.title
            row.tag = result.tag
            row.orderNum = result.orderNum
            row.urlType = result.urlType
            row.url = result.url
          } else {
            this.getPage()
          }
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateSysWarmTipState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
